import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import { MdClose } from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Card } from "components/Card/Card.jsx";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import ReactJson from "react-json-view";
import User from "../../../helper/User";
import isEqual from 'lodash.isequal';
class APIToken extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apiModal: false,
            apiUrl: '',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
                'Accept-Encoding': 'gzip, deflate',
                'Connection': 'keep-alive',
                'cache-control': 'no-cache',
            },
            sample_request: [],
            success_response: {},
            failure_response: {},
            api_token: '',
            api_token_copied: false,
            apiUrl_copied: false,
            Headers_copied: false,
            sample_request_copied: false,
            success_response_copied: false,
            failure_response_copied: false,
        }
    }
    componentDidMount() {
        const { location, rest_conf } = this.props;
        if (location.state) {
            const { state } = location;
            const { response } = state;
            this.setState({
                ...this.state,
                apiUrl: response.rest_api_path,
                sample_request: response.api_request_sample,
                success_response: response.api_success_response_sample,
                failure_response: response.api_failure_response_sample,
                api_token: response.api_token,
            })
        }
        else if (rest_conf) {
            this.setState({
                ...this.state,
                apiUrl: rest_conf.rest_api_path,
                sample_request: rest_conf.api_request_sample,
                success_response: rest_conf.api_success_response_sample,
                failure_response: rest_conf.api_failure_response_sample,
                api_token: rest_conf.api_token,
            })
        }
    }
    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.rest_conf, prevProps.rest_conf) && this.props.rest_conf !== undefined) {
            const { rest_conf } = this.props;
            this.setState({
                ...this.state,
                apiUrl: rest_conf.rest_api_path,
                sample_request: rest_conf.api_request_sample,
                success_response: rest_conf.api_success_response_sample,
                failure_response: rest_conf.api_failure_response_sample,
                api_token: rest_conf.api_token,
            })
        }
    }
    returnJson = (data) => {
        return <ReactJson
            displayDataTypes={false}
            displayObjectSize={false}
            enableClipboard={false}
            name={false}
            src={data} />
    }
    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            ctTableResponsive
                            content={
                                <div>
                                    <Grid fluid>
                                        <Row>
                                            <Col md={12}>
                                                <div className="flexElem">
                                                    <div className="flexElem alignStart mr-lg" style={{ width: '25%' }}>
                                                        <div className="apiLabel">
                                                            Verb
                                                        </div>
                                                        <div className="apiField">
                                                            Post
                                                        </div>
                                                    </div>

                                                    <div className="flexElem alignStart" style={{ width: '75%' }}>
                                                        <div className="flexElem alignStart" style={{ width: '100%' }}>
                                                            <div className="apiLabel text-right">
                                                                API URL
                                                            </div>
                                                            <div className="apiField">
                                                                {this.props.authentication_api ? this.state.apiUrl : process.env.REACT_APP_SYNC_URL}
                                                            </div>
                                                            <div className="copyAction">
                                                                <CopyToClipboard text={this.props.authentication_api ? this.state.apiUrl : process.env.REACT_APP_SYNC_URL}
                                                                    onCopy={() => this.setState({ copied: true })}>
                                                                    <span className="copyClipboard">&nbsp;</span>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-lg">
                                                    <div className="flexElem alignStart" style={{ width: '100%' }}>
                                                        <div className="apiLabel">
                                                            Headers
                                                    </div>
                                                        <div className="apiField">
                                                            {this.returnJson(this.state.headers)}

                                                        </div>
                                                        <div className="copyAction">
                                                            <CopyToClipboard text={JSON.stringify(this.state.headers, null, 3)}
                                                                onCopy={() => this.setState({ copied: true })}>
                                                                <span className="copyClipboard">&nbsp;</span>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-lg">
                                                    <div className="flexElem alignStart" style={{ width: '100%' }}>
                                                        <div className="apiLabel">
                                                            Sample Request
                                                    </div>
                                                        <div className="apiField">
                                                            {this.returnJson(this.state.sample_request)}
                                                        </div>
                                                        <div className="copyAction">
                                                            <CopyToClipboard text={JSON.stringify(this.state.sample_request, null, 3)}
                                                                onCopy={() => this.setState({ copied: true })}>
                                                                <span className="copyClipboard">&nbsp;</span>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-lg">
                                                    <div className="flexElem alignStart" style={{ width: '100%' }}>
                                                        <div className="apiLabel">
                                                            Success Response
                                                    </div>
                                                        <div className="apiField">
                                                            {this.returnJson(this.state.success_response)}
                                                        </div>
                                                        <div className="copyAction">
                                                            <CopyToClipboard text={JSON.stringify(this.state.success_response, null, 3)}
                                                                onCopy={() => this.setState({ copied: true })}>
                                                                <span className="copyClipboard">&nbsp;</span>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-lg">
                                                    <div className="flexElem alignStart" style={{ width: '100%' }}>
                                                        <div className="apiLabel">
                                                            Failure Response
                                                    </div>
                                                        <div className="apiField">
                                                            {this.returnJson(this.state.failure_response)}
                                                        </div>
                                                        <div className="copyAction">
                                                            <CopyToClipboard text={JSON.stringify(this.state.failure_response, null, 3)}
                                                                onCopy={() => this.setState({ copied: true })}>
                                                                <span className="copyClipboard">&nbsp;</span>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>

                                                {
                                                    this.props.hideButtons ?
                                                        null
                                                        :
                                                        <div className="text-center mt-xlg">
                                                            <button className="customBtn btnBlack m-md"
                                                                type="button" onClick={() => { this.props.history.push(`/Admin/brand/${this.props.location.state.brand_id}/data-definitions`) }}>
                                                                Exit
                                                    </button>

                                                            <button className="customBtn btnBlue m-md"
                                                                type="button"
                                                                onClick={() => { this.setState({ apiModal: !this.state.apiModal }) }}>
                                                                Show Code
                                                    </button>
                                                        </div>
                                                }
                                            </Col>
                                        </Row>
                                    </Grid>
                                </div>
                            }
                        />

                        <Modal show={this.state.apiModal} aria-labelledby="ModalHeader">
                            <Modal.Body style={{ wordBreak: 'break-all' }}>
                                <span className="modalCloseBtn" onClick={() => { this.setState({ apiModal: !this.state.apiModal }) }}><MdClose /></span>
                                <div className="modalCode p-md text_16">
                                    <div>POST: {this.state.apiUrl}</div> <br />
                                    <div>Host: {process.env.REACT_APP_HOST_NAME}</div> <br />
                                    <div>Authorization: Bearer {User.userBearer()}</div> <br />
                                    <div>Content-Type: application/x-www-form-urlencoded</div>
                                    <div>Cache-Control: no-cache</div>
                                    <div>Accept-Encoding: gzip, deflate</div>                                     <div>Connection: keep-alive </div> <br />
                                    {this.returnJson(this.state.sample_request)}

                                </div>
                            </Modal.Body>
                        </Modal>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    const { list_types } = state.listReducer;
    return {
        list_types
    };
}

export default withRouter(connect(
    mapStateToProps,
    null
)(APIToken));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/APIToken.jsx